// extracted by mini-css-extract-plugin
export default {"input":"lA1MXV","textInput":"KcVwEk","mobile":"uK_5cc"};